// extracted by mini-css-extract-plugin
export var next = "work-single-module--next--dfbdd";
export var nextPrevHeading = "work-single-module--nextPrevHeading--eb8f3";
export var nextPrevious = "work-single-module--nextPrevious--cc853";
export var previous = "work-single-module--previous--db91f";